import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import Button from "@shared/v2/Button";
import ZoomCard from "./shared/ZoomCard";
import { useIsLever, useIsPlace } from "../reducers/layoutReducer/selectors";
import useActiveProducts from "../Products/hooks/useActiveProducts";
import { ProductFamilyIds } from "../Products/constants";

const PhoneSystemCard = () => {
  const isPlace = useIsPlace();
  const isLever = useIsLever();
  const { activeProducts } = useActiveProducts(ProductFamilyIds.PhoneSystem);
  const isPhoneSystemActive = isPlace || isLever || activeProducts.length > 0;

  return (
    <ZoomCard
      actions={
        <>
          {isPhoneSystemActive && (
            <TextButton
              className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
              size="medium"
              onClick={() => window.open("/phone_system", "_blank")}
            >
              Launch Phone System <ArrowUpRightFromSquareSolidV6 />
            </TextButton>
          )}

          {!isPhoneSystemActive && (
            <div className="tw-flex tw-gap-[8px]">
              <Button
                size="medium"
                schema="secondary"
                onClick={() => window.location.assign("/phone_system?signup")}
              >
                Purchase
              </Button>
              <TextButton size="medium" onClick={() => window.location.assign("/phone_system")}>
                Learn More
              </TextButton>
            </div>
          )}
        </>
      }
      title="Phone System"
      onClick={() => window.location.assign("/phone_system")}
      onClickText={isPhoneSystemActive ? "Launch" : "Learn More"}
      subscribed={isPhoneSystemActive}
      description="Make it easier to connect with your leads, gain insight into your marketing campaigns, and understand your ROI like never before."
      imgSrc="/images/bg-card-phone-system.jpg"
      imgClassName="tw-mt-[24px] tw-ml-[45px] tw-mr-[-12px] tw-rounded-[6px] tw-shadow-md tw-overflow-hidden"
    />
  );
};

export default PhoneSystemCard;
